<div class="flex flex-row items-center gap-2 shadow-xl shadow-iota-inh-green/25">
    <div class="avatar items-start" *ngIf="(logo$ | ngrxPush)?.loading">
        <div class="spinner spinner-primary w-11"></div>
    </div>

    <div class="avatar items-start w-11" *ngIf="(logo$ | ngrxPush)?.url && !(logo$ | ngrxPush)?.loading">
        <div class="w-11 rounded-lg bg-white relative">
            <img [src]="(logo$ | ngrxPush)?.url" class="rounded-lg !object-contain absolute" />
        </div>
    </div>

    <div class="avatar placeholder items-start" *ngIf="!(logo$ | ngrxPush)?.url && !(logo$ | ngrxPush)?.loading">
        <div class="w-11 rounded-lg bg-neutral text-neutral-content">
            <span class="uppercase">{{ initials }}</span>
        </div>
    </div>
</div>
